module.exports = __webpack_public_path__ + "img/flakes-power-cup.6a3d968b.png";